// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__content--wAaBI {\n  font-size: 16px;\n  line-height: 1.75;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/operation/HelloKlarityPageManagement/components/MedicationManagement/components/DeleteMedicationModal/s.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;AACF","sourcesContent":[".content {\n  font-size: 16px;\n  line-height: 1.75;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "s-module__content--wAaBI"
};
export default ___CSS_LOADER_EXPORT___;
